<div class="na-wrap">
  <div class="na-card">

    <!-- Icon -->
    <div class="na-icon-wrap">
      <div class="na-icon-ring">
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <rect x="4" y="11" width="16" height="9" rx="2"/>
          <path d="M8 11V8a4 4 0 0 1 8 0v3"/>
          <circle cx="12" cy="15.5" r="1.2" fill="currentColor" stroke="none"/>
        </svg>
      </div>
      <span class="na-code">403</span>
    </div>

    <!-- Title -->
    <h1 class="na-title">{{ 'noAccess.title' | translate }}</h1>

    <!-- Module badge (shown when we know which module was blocked) -->
    <div class="na-module-badge" *ngIf="moduleName">
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="11" width="16" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>
      {{ moduleName }}
    </div>

    <p class="na-sub">{{ 'noAccess.sub' | translate }}</p>

    <!-- Logged-in user pill -->
    <div class="na-user-pill" *ngIf="userName">
      <span class="na-user-av">{{ userName.charAt(0).toUpperCase() }}</span>
      <span class="na-user-name">{{ userName }}</span>
      <span class="na-role-badge">{{ userRole }}</span>
    </div>

    <!-- Info box -->
    <div class="na-info">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" style="flex:0 0 auto;margin-top:1px"><circle cx="12" cy="12" r="10"/><path d="M12 8v4M12 16h.01"/></svg>
      {{ 'noAccess.hint' | translate }}
    </div>

    <!-- Actions -->
    <div class="na-actions">
      <button class="btn btn-primary" (click)="goBack()">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
        {{ 'noAccess.goHome' | translate }}
      </button>
    </div>

  </div>
</div>
